import * as React from 'react'
import { useLocation } from 'react-router-dom'
import mixDataConfig from '../setup/SingleDataConfig';
import Navbar from '../setup/Navbar';
import { Container, Grid2, Box } from '@mui/material';
import HeadingTest from '../../BuiltInComponent/HeadingTest'
import TextField from '../../BuiltInComponent/TextField'
import ButtonNormal from '../../BuiltInComponent/ButtonNormal'
import StickTable from '../../BuiltInComponent/TableWithPagination'
import { addNewSingleFieldData, getAllSingleFieldData } from '../../features/AdminManagement/singleFieldSlice'
import { useDispatch, useSelector } from 'react-redux';

export default function SingleDataScreen() {

    const dispatch = useDispatch()
    const location = useLocation();
    const routePath = location.pathname.replace("/", "").replace("/", "");
    const config = mixDataConfig[routePath];

    const { singleFieldData } = useSelector(state => state.sf)
    const [singleField, setSingleField] = React.useState(
        {
            sfID: null,
            sfScreen: config.sfScreen,
            sfHead: config.sfHead,
            sfDescription: '',
            sfStatus: true
        })
    React.useEffect(() => {
        setSingleField(prevData => ({
            ...prevData,
            sfScreen: config.sfScreen,
            sfHead: config.sfHead,

        }))
    }, [config])

    React.useEffect(() => {
        dispatch(getAllSingleFieldData({
            sfScreen: config.sfScreen,
            sfHead: config.sfHead
        }))
    }, [dispatch, config.sfScreen, config.sfHead])

    const onChange = (data) => {
        const keys = Object.keys(data)
        setSingleField(prevData => ({
            ...prevData, sfDescription: data[keys]
        }))
    }

    const onClick = () => {
        dispatch(addNewSingleFieldData(singleField)).then(() => {
            setSingleField(prevData => ({
                ...prevData, sfDescription: ''
            }))
        })
    }

    const onEditClick = async (id) => {
        console.log(id)
    }

    const onDeleteClick = async (id) => {
        console.log(id)

    }

    const tableColumns = [
        { fieldName: 'sfID', cName: 'trNo', dType: 'string', width: 10, textAlign: 'left', status: 'en' },
        { fieldName: 'sfDescription', cName: config.fieldLabel, dType: 'string', width: 1000, textAlign: 'left', status: 'en' },
        { fieldName: 'editButton', cName: 'Edit', dType: 'decimal', width: 10, textAlign: 'center', status: 'en' },
        { fieldName: 'deleteButton', cName: 'Delete ', dType: 'decimal', width: 10, textAlign: 'left', status: 'en' },
        { fieldName: 'button', cName: 'button ', dType: 'decimal', width: 10, textAlign: 'center', status: 'dis' },
    ]

    return (
        <>
            <Navbar />
            <Container >

                <Grid2 container spacing={2} sx={{ m: 1 }}>
                    <Grid2 size={3.5}></Grid2>
                    <Grid2 size={5} sx={{ border: '1px solid grey', borderRadius: 1, boxShadow: '1px 1px 2px grey', p: 1 }}>
                        <Box sx={{ mb: 2 }}>
                            <HeadingTest text={config.heading} />
                        </Box>
                        <TextField id={singleField} name={singleField} label={config.fieldLabel} onChange={onChange} value={singleField.sfDescription} />
                        <Box sx={{ mt: 1 }}>
                            <ButtonNormal text={`Add`} onClick={onClick} />
                        </Box>
                        <Box sx={{ mt: 1 }}>
                            <StickTable
                                tableData={singleFieldData && singleFieldData}
                                tableColumns={tableColumns}
                                perPage={10}
                                onEditClick={onEditClick}
                                onDeleteClick={onDeleteClick} />
                        </Box>
                    </Grid2>
                    <Grid2 size={3.5}></Grid2>
                </Grid2>

            </Container>
        </>
    )
}